import React, { useEffect, useState } from 'react';
import Helmet from '~/components/Helmet/Helmet';
import { useConfigMC } from '~/store/Query/api';

const SetMetatags = ({
  title = '',
  description = ''
}) => {

  if (!title || !description) {

    return (
      <div></div>
    )

  }

  return (
    <Helmet title={title}>
      {description && <meta name="description" content={description} />}
    </Helmet>
  );
};

export default SetMetatags;
